const typeToString = (type) =>
  type === 128 || type === 'OTAA' ? 'OTAA' : 'ABP'
const typeToInt = (type) => (type === 128 || type === 'OTAA' ? 128 : 0)

export { typeToInt, typeToString }
